module.exports = __webpack_public_path__ + "img/2-2.20c9702e.png";